import React, {useState, useEffect} from "react";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const images = {normal: require("../assets/logo-white.png"), scroll: require("../assets/logo-sm-light.png")};

function Footer() {


    return (
       <></>
    );
}

export default Footer;